"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash.noop"));
var _constants = require("../constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var propTypes = {
  targetNode: _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(window.Element), _propTypes["default"].element]),
  isVisible: _propTypes["default"].bool,
  hasShadow: _propTypes["default"].bool,
  shouldCloseOnEsc: _propTypes["default"].bool,
  shouldCloseOnOverlayClick: _propTypes["default"].bool,
  allowOutsideClick: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func]),
  disableAutoFocus: _propTypes["default"].bool,
  size: _propTypes["default"].oneOf(Object.values(_constants.MODAL_SIZE)),
  width: _propTypes["default"].string,
  height: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  children: _propTypes["default"].any,
  testId: _propTypes["default"].string,
  theme: _propTypes["default"].object,
  modalProps: _propTypes["default"].object
};
exports.propTypes = propTypes;
var defaultProps = {
  targetNode: window.document.body,
  isVisible: true,
  hasShadow: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: false,
  allowOutsideClick: undefined,
  disableAutoFocus: false,
  size: _constants.MODAL_SIZE.MEDIUM,
  width: undefined,
  height: undefined,
  onClose: _lodash["default"],
  children: null,
  testId: 'MODAL',
  theme: {},
  modalProps: {}
};
exports.defaultProps = defaultProps;